export default __webpack_public_path__ + "static/Conditions générales de vente Bollène Aventure-FR-b94d0b9bcd076830c034700c3f2e151b.pdf";